import ApiService from './api.service';

class EventService {
  async list() {
    try {
      const response = await ApiService.get('/event');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/event/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/event/update', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/event/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new EventService(); 